import "./agent.card.css";

const ProviderComponent = ({
  title = "",
  description = "",
  titleClassName = "",
  textClassName = "",
  containerClassName = ""
}) => (
  <div className={containerClassName}>
    <div className={titleClassName}>{title}</div>
    <div className={textClassName}>{description}</div>
  </div>
);

export default ProviderComponent;
